export default __webpack_public_path__ + "static/media/playlist-cancel.c30eab84.svg";